<template>
    <div>
      <div class="modal hide fade" id="modalManufactureForm" tabindex="-1" role="dialog" aria-labelledby="modalManufactureForm" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title"><b>Manufacture</b></h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div class="row">
                    <div class="col-md-6">
                        <dl class="row dl-custom">
                            <dt class="col-md-4">Manufacture No.</dt>
                            <dd class="col-md-8">
                                {{ manufacture.manufacture_no }}
                                <span class="badge badge-primary" v-if="manufacture.status === 'finish'">{{ manufacture.status }}</span>
                                <span class="badge badge-success" v-else>{{ manufacture.status }}</span>
                            </dd>

                            <dt class="col-md-4">Date</dt>
                            <dd class="col-md-8">{{ manufacture.manufacture_date | dateFormat('DD/MM/YYYY') }}</dd>

                            <dt class="col-md-4">Finish Date</dt>
                            <dd class="col-md-8">{{ manufacture.manufacture_finish_date | dateFormat('DD/MM/YYYY') }}</dd>

                            <dt class="col-md-4">Company</dt>
                            <dd class="col-md-8">{{ manufacture.company }}</dd>
                        </dl>
                    </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <ul class="nav nav-tabs nav-bordered">
                    <li class="nav-item"><a href="#mproduct-tab" data-toggle="tab" aria-expanded="false" class="nav-link active">Product</a></li>
                    <li class="nav-item"><a href="#material-tab" data-toggle="tab" aria-expanded="false" class="nav-link">Material</a></li>
                  </ul>
                  <div class="tab-content">
                    <div class="tab-pane active" id="mproduct-tab">
                      <div class="table-responsive">
                        <table class="table table-sm table-item table-hover table-striped">
                          <thead>
                            <th>Product</th>
                            <th class="text-center">Qty</th>
                            <th>Uom</th>
                            <th class="text-right">Price</th>
                            <th class="text-right">Total</th>
                          </thead>
                          <tbody>
                            <tr v-for="mp in summaryMProduct" :key="mp.id">
                              <td><b>[{{ mp.product_no}}]</b> {{ mp.product }}</td>
                              <td class="text-center">{{ mp.qty_estimated }}</td>
                              <td>{{ mp.uom_id }}</td>
                              <td class="text-right">{{ mp.price | currency }}</td>
                              <td class="text-right">{{ mp.total | currency }}</td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td class="text-right"><b>{{ totalMProduct | currency }}</b></td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                    <div class="tab-pane" id="material-tab">
                      <div class="table-responsive">
                        <table class="table table-sm table-item table-hover table-striped">
                          <thead>
                            <th>Product No</th>
                            <th>Category</th>
                            <th>Qty</th>
                            <th>Uom</th>
                            <th class="text-right">Price</th>
                            <th class="text-right">Total</th>
                          </thead>
                          <tbody>
                            <tr v-for="s in summaryMaterial" :key="s.id">
                              <td><b>[{{ s.product_no }}]</b> {{ s.product }}</td>
                              <td>{{ s.category_id }}</td>
                              <td>{{ s.qty }}</td>
                              <td>{{ s.uom_id }}</td>
                              <td class="text-right">{{ s.price | currency }}</td>
                              <td class="text-right">{{ s.total | currency }}</td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td class="text-right"><b>{{ totalSummaryMaterial | currency }}</b></td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <pre>{{ manufacture }}</pre> -->
            </div>
            <div class="modal-footer">
              <!-- <button type="button" class="btn btn-hard-primary" data-dismiss="modal" @click="process">Process</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ManufactureFormModal',
  computed: {
    ...mapState({
      manufacture: state => state.manufactures.manufacture
    }),
    totalSummaryMaterial () {
      var array = this.summaryMaterial
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalMProduct () {
      var sum = 0
      var array = this.manufacture.mproducts
      if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    summaryMProduct () {
      var result = []
      var array = this.manufacture.mproducts
      for (let i = 0; i < array.length; i++) {
        var obj = {
          id: array[i].id,
          product_no: array[i].product_no,
          product: array[i].product,
          qty_estimated: array[i].qty_estimated,
          uom_id: array[i].uom_id,
          price: array[i].price,
          total: array[i].total
        }
        result.push(obj)
      }
      return result
    },
    summaryMaterial () {
      var result = []
      var array = this.manufacture.materials
      if (array.length > 0) {
        array.reduce(function (res, value) {
          var key = value.product_no
          if (!res[key]) {
            res[key] = {
              product_no: value.product_no,
              product: value.product,
              qty: value.qty,
              uom_id: value.uom_id,
              price: parseFloat(value.price),
              total: value.total_cogs
            }
            result.push(res[key])
          } else {
            res[key].qty = parseFloat(res[key].qty) + parseFloat(value.qty)
            res[key].price = parseFloat(value.price.replace(/\./g, ''))
            res[key].total = parseFloat(res[key].total) + parseFloat(value.total_cogs)
          }
          return res
        }, {})
      }
      return result
    },
    totalCogs () {
      var sum = 0
      for (let i = 0; i < this.manufacture.materials.length; i++) {
        sum += parseFloat(this.manufacture.materials[i].total_cogs)
      }
      return sum
    },
    detailList () {
      var array = this.manufacture.materials
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          id: array[i].id,
          manufacture_no: array[i].manufacture_no,
          product_no: array[i].product_no,
          qty: array[i].qty,
          uom_id: array[i].uom_id,
          price: array[i].price,
          total_cogs: array[i].total_cogs,
          warehouse_no: array[i].warehouse_no,
          receive: array[i].receive,
          received_by: array[i].received_by,
          receive_date: array[i].receive_date,
          manufacture_date: array[i].manufacture_date,
          company_no: array[i].company_no,
          branch_no: array[i].branch_no,
          category_id: array[i].category_id,
          type_id: array[i].type_id,
          hand_id: array[i].hand_id,
          mproduct_no: array[i].mproduct_no
        }
        loop.push(obj)
      }
      return loop
    }
  },
  methods: {
    process () {
      this.$emit('setPriceProduct', this.totalCostItem)
    }
  }
}
</script>
